export function DocumentsKnowledgeBaseSidebar({ knowledgeBases, selectedKB, onSelect }) {
  return (
    <div className="w-64 space-y-2" data-testid="documents-kb-sidebar">
      <h3 className="mb-3 text-xs font-mono uppercase tracking-widest text-muted-foreground/60">
        Bases de connaissances
      </h3>
      {knowledgeBases.map((knowledgeBase) => (
        <button
          key={knowledgeBase.id}
          type="button"
          data-testid={`documents-kb-${knowledgeBase.id}`}
          onClick={() => onSelect(knowledgeBase)}
          className={`w-full rounded-sm border p-3 text-left transition-all ${
            selectedKB?.id === knowledgeBase.id
              ? 'border-white bg-white/10'
              : 'border-zinc-800 bg-transparent hover:border-white'
          }`}
        >
          <div className="truncate font-medium">{knowledgeBase.name}</div>
          <div className="text-xs text-muted-foreground">{knowledgeBase.document_count || 0} documents</div>
        </button>
      ))}
    </div>
  );
}
